import { useEffect, useState } from 'react'

const isRatioLandscape = () => {
  const width =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const height =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

  return width / 16 > height / 9
}

export function useIsRatioLandscape() {
  // save current window width in the state object
  let [isLandscape, setIsLandscape] = useState(isRatioLandscape())

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId = null
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId)
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => setIsLandscape(isRatioLandscape()), 150)
    }
    // set resize listener
    window.addEventListener('resize', resizeListener)

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener)
    }
  }, [])

  return isLandscape
}
